<template>
    <div class="nav-bar">
        <van-tabbar v-model="active" active-color="#E34928" inactive-color="#666666">
            <van-tabbar-item icon="wap-home-o" @click="go_index">首页</van-tabbar-item>
            <van-tabbar-item icon="orders-o" @click="go_order">订单</van-tabbar-item>
            <van-tabbar-item icon="setting-o" @click="go_account">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import config from '@/config';

    export default {
        name: "PartnerFooter",
        props:{
            p_active:{
                type:String,
                default:'0',
                required:true
            }
        },
        data(){
            return{
                active:parseInt(this.p_active),
                mode:config.mode,   //1梅唐四季（终端用户），2耘径联盟（代理人用户）
            }
        },
        methods:{
            go_index(){
                this.$router.push({name:'home',params:{}});
            },
            go_order(){
                if(this.mode==1){
                    this.$router.push({name:'MyOrderClient'});
                }else{
                    this.$router.push({name:'MyOrderAgent'});
                }
            },
            go_account(){
                this.$router.push({name:'Account'});
            },
        }
    }
</script>

<style scoped>
    .nav-bar{
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 10px 0;
        z-index: 1000;
        background: #fff;
        transform: translateZ(0);
        -webkit-transform: translateZ(0);
        font-size: 30px;
    }
</style>